/**
 * Contrato de auth que vive no browser — chaves de localStorage, eventos
 * customizados e paths de UI. Importado por código client (`AuthManager`,
 * stores, providers) e também por código server quando precisa "instruir"
 * o browser (ex.: HTML de handoff renderizado no servidor).
 */

export const AUTH_STORAGE_KEY =
  process.env.NEXT_PUBLIC_AUTH_STORAGE_KEY ?? "agros_auth";

export const LEGACY_PROFILE_STORAGE_KEY =
  process.env.NEXT_PUBLIC_LEGACY_PROFILE_STORAGE_KEY ?? "agros_auth_legacy";

export const AUTH_MANAGER_CHANGE_EVENT = "auth-manager:change";

export const AUTH_MANAGER_LEGACY_CHANGE_EVENT = "auth-manager-legacy:change";

export const LOGIN_PAGE_PATH = "/login";

export const REDIRECT_AFTER_LOGIN = "/inicio";
